import React from 'react';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { MethodSection } from './components/MethodSection';
import { BonusStack } from './components/BonusStack';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { useMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useMetaPixel();
  return <div className="w-full bg-zinc-950 font-sans antialiased" data-id="element-0" data-mp="31agnwnhawdix">
      <Hero data-id="element-1" data-mp="31c1ksjr388jy" />
      <main data-id="element-2" data-mp="31cjo20c63n1d">
        <PainSection data-id="element-3" data-mp="2wk06ksad07ra" />
        <MethodSection data-id="element-4" data-mp="2wjqhd6x524mn" />
        <BonusStack data-id="element-5" data-mp="2wj8g1vvmd07v" />
        <OfferSection data-id="element-6" data-mp="2whx9xpepbgdl" />
        <GuaranteeSection data-id="element-7" data-mp="28ufoscpxzgjl" />
        <FaqSection data-id="element-8" data-mp="28tmdqzjya4vn" />
        <FinalCta data-id="element-9" data-mp="28t4j27cxrypu" />
      </main>
      <Footer data-id="element-10" data-mp="28s2y9b64bxux" />
    </div>;
}